import { googleTools } from '@ai-sdk/google/internal';

export const googleVertexTools = {
  googleSearch: googleTools.googleSearch,
  enterpriseWebSearch: googleTools.enterpriseWebSearch,
  googleMaps: googleTools.googleMaps,
  urlContext: googleTools.urlContext,
  fileSearch: googleTools.fileSearch,
  codeExecution: googleTools.codeExecution,
  vertexRagStore: googleTools.vertexRagStore,
};
